import { Link } from 'react-router-dom';
import { EPDStatusDisplayName } from 'services/EpdClient';
import styled, { css } from 'styled-components';
import { H2 } from 'styles/Styles.styled';

export const InfoBox = styled.div`
  display: flex;
  padding: 1rem;
  border-left: solid 3px green;
  margin: 0.5rem 0;
  background-color: #f3f3f3;
  margin-right: 1vw;
`;

export const AccountDropDownItem = styled.div`
  padding: 1rem;
  min-width: 250px;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.lightGreen};
  }
`;

export const CardsEmpty = styled.div`
  width: 814px;
  height: 515px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${(props) => props.theme.colors.primaryWhite};
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
`;

export const CardSmallText = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 100%;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

export const CardFormatText = styled(CardSmallText)`
  margin-bottom: 4px;
`;

export const CardDate = styled(CardSmallText)`
  font-style: normal;
  text-transform: uppercase;
`;

export const CardStatus = styled.div<{ status?: EPDStatusDisplayName }>`
  ${(props) => props.theme.typography.headerCaptionMedium};
  border-radius: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  color: ${(props) => props.theme.colors.primaryBlack80};

  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  padding: 4px 10px;
  background-color: ${(props) => props.theme.colors.statusLabelGrayBg};

  ${(props) =>
    (props.status === EPDStatusDisplayName.SentForVerification ||
      props.status === EPDStatusDisplayName.ReadyToPublish ||
      props.status === EPDStatusDisplayName.LicenseeReview ||
      props.status === EPDStatusDisplayName.Updating ||
      props.status === EPDStatusDisplayName.SentForPublication) &&
    css`
      color: ${(props) => props.theme.colors.statusLabelYellowText};
      background-color: ${(props) => props.theme.colors.statusLabelYellowBg};
    `}

  ${(props) =>
    (props.status === EPDStatusDisplayName.DeclinedPublication ||
      props.status === EPDStatusDisplayName.Deregistered ||
      props.status === EPDStatusDisplayName.Depublished ||
      props.status === EPDStatusDisplayName.DeclinedVerification) &&
    css`
      color: ${(props) => props.theme.colors.statusLabelRedText};
      background-color: ${(props) => props.theme.colors.statusLabelRedBg};
    `}
  
    ${(props) =>
    props.status === EPDStatusDisplayName.Published &&
    css`
      color: ${(props) => props.theme.colors.statusLabelGreenText};
      background-color: ${(props) => props.theme.colors.statusLabelGreenBg};
    `}
`;

export const CardName = styled.div`
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const CardHeading = styled.h4`
  margin: 16px 0 8px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  text-transform: uppercase;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

export const OrgHeading = styled(H2)`
  margin: 0;
`;

export const OrganisationContainer = styled.div`
  margin: 1rem;
  margin-left: 0rem;
  display: flex;
  justify-content: space-between;
`;

export const Card = styled(Link)<{ background?: string }>`
  height: 200px;
  position: relative;
  overflow: hidden;
  border: solid 1px ${(props) => props.theme.colors.gray};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.11), 0 2px 2px rgba(0, 0, 0, 0.11), 0 4px 4px rgba(0, 0, 0, 0.11);

  text-decoration: none;
  color: black;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 1rem;

  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  font-weight: bold;

  &:hover {
    background-color: #b4d0b633;
    border: solid 2px ${(props) => props.theme.colors.secondaryLightGreen};
  }
`;
export const CopyGroupCard = styled(Card)`
  // TODO: remove or uncomment after UI/UX review
  /* box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.11), 2px 2px 1px rgba(255, 255, 255, 1), 4px 4px 1px rgba(0, 0, 0, 0.11),
    6px 6px 4px rgba(0, 0, 0, 0.11); */
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
`;

export const ListViewContainer = styled.div`
  width: 100%;
  padding: 30px;
  background-color: ${({ theme }) => theme.colors.primaryWhite};
  border-radius: 4px;
  box-sizing: border-box;
`;

export const HeadingArea = styled.div<{ $emptyCompany?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(props) => (props.$emptyCompany ? '58px' : '40px')};
`;

export const QuickFactValue = styled.div.attrs((props: { highlight: boolean }) => ({ highlight: props.highlight ?? false }))`
  display: flex;
  justify-content: flex-end;

  div {
    ${(props) =>
      props.highlight
        ? css`
            background: ${(props) => props.theme.colors.darkOrange};
            color: white;

            :hover {
              border: 1px solid ${(props) => props.theme.colors.darkOrange};
              background: white;
              color: ${(props) => props.theme.colors.darkOrange};
            }
          `
        : ''}
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    min-width: 1.5rem;
    height: 1.5rem;
    border-radius: 0.75rem;
    padding: 0 0.2rem;
  }
`;
